export default class Dealer {
  constructor(token, userDetails, history) {
    if (userDetails) {
      this.dealerType = userDetails.dealerType;
      this.dealerId = userDetails.dealerId;
      this.loggedInDealerId = userDetails.dealerId;
      this.userId = userDetails.userId;
      this.commonName = userDetails.commonName;
      this.market = userDetails.market;
      this.fullName = userDetails.fullName;
      this.userType = userDetails.userType;
      this.isDealerAdmin = userDetails.dealerAdmin;
      this.isDealerSalesManager = userDetails.dealerSalesManager;
      this.isDealerUsedCarsSalesManager =
        userDetails.dealerUsedCarsSalesManager;
      this.isDealerPrincipal = userDetails.dealerPrincipal;
      this.permissions = userDetails.permissions;
      this.commonId = userDetails.commonId;
      this.brand = userDetails.brand;
      this.dealersNotFullyOnboarded = null;
      this.toggleDisabledDealers = null;
      this.superGroupUser = userDetails.superGroupUser;
    }
    this.showAll = true;
    this.token = token;
    this.history = history;
  }

  isMainDealer(dealerType) {
    return dealerType === "MDLR" || dealerType === "HUB";
  }

  isBranchDealer(dealerType) {
    return dealerType === "BRAN" || dealerType === "SDLR";
  }

  generateResourcePath() {
    return `dealer/${this.dealerId}`;
  }

  generateNSCResourcePath() {
    return `nsc/${this.market}`;
  }

  updateBusinessSettingsTab(tab) {
    this.businessSettingsPage = tab;
  }

  updateDashboardTab(tab) {
    this.dashboardPage = tab;
  }

  updatePendingActions(pendingActions) {
    this.pendingActions = pendingActions;
  }

  showPricingWarning(showWarning) {
    this.showPricingWarningMessage = showWarning;
  }

  updateCurrentDealer(currentDealer, showAll) {
    this.dealerId = currentDealer.completeDealerId;
    this.salesCode = currentDealer.salesCode;
    this.commonId = currentDealer.commonId;
    this.name = currentDealer.name;
    this.showAll = showAll;
    this.isActive = currentDealer.isOnboarded;
    this.dealerType = currentDealer.dealerType;
    this.readOnly = !!(this.isLoggedInUserMDLR && "SDLR" === this.dealerType);
    return this;
  }

  setDealerGroup(dealerGroup) {
    this.dealerGroup = dealerGroup;
    this.isLoggedInUserMDLR =
      dealerGroup.filter(
        (d) => d.dealerType === "HUB" || "MDLR" === d.dealerType
      ).length >= 1;

    const dealerGroupingsMap = {};
    const dealerGroupingsMapByDealerId = {};
    this.dealerGroup.forEach((dealer) => {
      dealerGroupingsMap[dealer.commonId] = dealer;
      dealerGroupingsMapByDealerId[dealer.completeDealerId] = dealer;
    });

    this.dealerGroupingsMap = dealerGroupingsMap;
    this.dealerGroupingsMapByDealerId = dealerGroupingsMapByDealerId;
  }

  getCommonIdsWithSDLR(filterByOnboarded = true) {
    return this.getDealerIdsOrCommonIds(filterByOnboarded, false, true);
  }

  getCurrentDealer() {
    return this.dealerGroup.filter(
      (dealer) => dealer.completeDealerId === this.dealerId
    )[0];
  }

  getCommonIdsWithoutSDLR(filterByOnboarded = true) {
    return this.getDealerIdsOrCommonIds(filterByOnboarded, true, true);
  }

  getDealerIdsWithSDLR(filterByOnboarded = true) {
    return this.getDealerIdsOrCommonIds(filterByOnboarded, false, false);
  }

  getDealerIdsWithoutSDLR(filterByOnboarded = true) {
    return this.getDealerIdsOrCommonIds(filterByOnboarded, true, false);
  }

  getDealerIdsOrCommonIds(filterByOnboarded, filterSDLR, isCommonId) {
    const ids = [];

    function getDealerOrCommonId(dealer, isCommonId) {
      let id;
      if (isCommonId) {
        id = dealer.commonId.split("|").join("%7C");
      } else {
        id = dealer.completeDealerId;
      }
      return id;
    }

    if (this.dealerGroup) {
      let dealerGroup = filterByOnboarded
        ? this.dealerGroup.filter((dealer) => dealer.isOnboarded)
        : this.dealerGroup;

      dealerGroup = dealerGroup.filter(
        (dealer) => dealer.hasAccessControlContainsActive
      );

      const currentDealer = dealerGroup.filter(
        (dealer) => dealer.completeDealerId === this.dealerId
      )[0];

      if (
        (currentDealer.dealerType === "HUB" ||
          "MDLR" === currentDealer.dealerType) &&
        this.showAll
      ) {
        //If logged in as Main and viewing as ALL
        dealerGroup.forEach((dealer) => {
          if (filterSDLR && dealer.dealerType === "SDLR") return;
          ids.push(getDealerOrCommonId(dealer, isCommonId));
        });
      } else if (
        this.loggedInDealerId === this.dealerId ||
        "SDLR" !== currentDealer.dealerType ||
        !filterSDLR
      ) {
        //If Main is viewing as Individual or SDLR/BRAN login individually or If Main not selects SDLR
        ids.push(getDealerOrCommonId(currentDealer, isCommonId));
      }
    }
    return ids.toString();
  }

  getCommonIdsForSearch() {
    const ids = [];

    function getDealerOrCommonId(dealer, isCommonId) {
      let id;
      if (isCommonId) {
        id = dealer.commonId.split("|").join("%7C");
      } else {
        id = dealer.completeDealerId;
      }
      return id;
    }

    if (this.dealerGroup) {
      let dealerGroup = this.dealerGroup.filter((dealer) => dealer.isOnboarded);

      if (!this.isIceEnabled()) {
        dealerGroup = dealerGroup.filter((dealer) => dealer.isBevDealer);
      }

      const currentDealer = dealerGroup.filter(
        (dealer) => dealer.completeDealerId === this.dealerId
      )[0];

      if (
        (currentDealer.dealerType === "HUB" ||
          "MDLR" === currentDealer.dealerType) &&
        this.showAll
      ) {
        //If logged in as Main and viewing as ALL
        dealerGroup.forEach((dealer) => {
          ids.push(getDealerOrCommonId(dealer, true));
        });
      } else {
        // If Main is viewing as Individual or SDLR/BRAN login individually
        ids.push(getDealerOrCommonId(currentDealer, true));
      }
    }
    return ids.toString();
  }

  reformatCommonId(commonId) {
    return commonId.split("%7C").join("|");
  }

  getPendingActionStatusForDealers(pendingActions, actionName) {
    if (
      !pendingActions ||
      pendingActions.filter(
        (pendingAction) => pendingAction.actionName === actionName
      ).length === 0
    ) {
      return [];
    }
    let dealerGroup = this.dealerGroup;
    if (!this.isIceEnabled()) {
      dealerGroup = dealerGroup.filter((dealer) => dealer.isBevDealer);
    }
    return pendingActions
      .filter((pendingAction) => pendingAction.actionName === actionName)
      .map((pendingAction) => {
        return dealerGroup
          .filter(
            (dealer) => this.isLoggedInUserMDLR && dealer.dealerType !== "SDLR"
          )
          .filter((dealer) => dealer.isOnboarded)
          .map((dealer) => {
            let dealerIds = [];
            if (pendingAction.attributes.dealerIds) {
              dealerIds = pendingAction.attributes.dealerIds;
            } else if (
              pendingAction.attributes &&
              pendingAction.attributes.vehicleLines
            ) {
              pendingAction.attributes.vehicleLines[0].dealerInfoList.forEach(
                (dealer) => {
                  dealerIds.push(dealer.dealerId);
                }
              );
            }
            return {
              dealerId: dealer.completeDealerId,
              dealerName: dealer.name,
              commonId: dealer.commonId,
              pendingActionStatus: !dealerIds.includes(dealer.completeDealerId),
            };
          });
      });
  }

  getPendingActionStatusForDealersByCatalogIdAndModelYear(
    pendingActions,
    actionName,
    catalogIds,
    model,
    year
  ) {
    if (
      pendingActions.filter(
        (pendingAction) => pendingAction.actionName === actionName
      ).length === 0
    ) {
      return [];
    }
    return pendingActions
      .filter((pendingAction) => pendingAction.actionName === actionName)
      .filter((pendingAction) => {
        const vehicleLines = pendingAction.attributes.vehicleLines.filter(
          (vehicleLine) => {
            return (
              catalogIds.includes(vehicleLine.catalogId) &&
              vehicleLine.model === model &&
              vehicleLine.year.toString() === year
            );
          }
        );
        return vehicleLines.length > 0;
      });
  }

  isIceEnabled = () => {
    return (
      this.permissions &&
      this.permissions.rolePermissions.hasOwnProperty("iceDealerCanView")
    );
  };

  // This function gets dealergroup and filters out non-onboarded
  // Differs from above function because it does not consider what current view is (Main v. all, etc)
  getOnboardedDealerGroup(filterSDLR = false) {
    if (this.dealerGroup) {
      let onboardedDealers = this.dealerGroup.filter(
        (dealer) => dealer.isOnboarded
      );
      onboardedDealers = onboardedDealers.filter(
        (dealer) => dealer.hasAccessControlContainsActive
      );
      return filterSDLR
        ? onboardedDealers.filter((dealer) => dealer.dealerType !== "SDLR")
        : onboardedDealers;
    } else {
      return [];
    }
  }

  updateUnOnboardedDealers(dealersToRemove, action) {
    if (this.dealersNotFullyOnboarded) {
      const dealers = this.dealersNotFullyOnboarded[action];
      const filteredDealers =
        dealers &&
        dealers.filter((dealer) => !dealersToRemove.includes(dealer));
      this.dealersNotFullyOnboarded[action] = filteredDealers;
    }
  }

  updateToggleDisabled(dealersToRemove, action) {
    if (this.toggleDisabledDealers) {
      const dealers = this.toggleDisabledDealers[action];
      const filteredDealers =
        dealers &&
        dealers.filter((dealer) => !dealersToRemove.includes(dealer));
      this.toggleDisabledDealers[action] = filteredDealers;
    }
  }

  getDealerList() {
    const dealers = [];
    let dealerList = this.getCommonIdsWithoutSDLR();
    if (dealerList) {
      dealerList = dealerList.split(",");
      dealerList.forEach((dealer) => {
        const formattedDealer = this.reformatCommonId(dealer);
        dealers.push(this.dealerGroupingsMap[formattedDealer].completeDealerId);
      });
    }
    return dealers;
  }
}
